
export default class EventListComponent {
  constructor() {
    this.el = $('#eventlist-component');

    if (!this.el.length) {
      return false;
    }

    this._loadTable = this._loadTable.bind(this);


    this.nextBtnRow = this.el.find('#morebtnrow');
    this.eventlist = this.el.find('#eventlist2');

    this.pageId = 2;
    var _this = this;
    this.el.find('#nextpageBtn').on('click', function () { _this._loadTable(_this.pageId++); });
    
  }



  _loadTable(pageId) {
    let _this = this;
    $.get('/List/EventList/' + pageId, function (data) {
      if (data && data.trim() != "") {
        let content = data;
        _this.eventlist.append(content);
        if (data.indexOf("<span id=\"endofeventlist\"></span>") >= 0) {
          _this.nextBtnRow.hide();
        }
      } else {
        _this.nextBtnRow.hide();
      }
    });
  }

}
